import React from 'react';
import StockInOutReport from './StockInOutReport';
import StockInOutReportMobile from './StockInOutReportMobile';
import ResponsiveWrapper from '../../../components/common/ResponsiveWrapper';


const StockInOutReportWrapper: React.FC = React.memo(() => {
  return (
    <>
      <ResponsiveWrapper
        mobileComponent={StockInOutReportMobile}
        desktopComponent={StockInOutReport}
      />
    </>
  );
});

StockInOutReportWrapper.displayName = 'StockInOutReportWrapper';

export default StockInOutReportWrapper; 